import React, { useState } from 'react';
import { ShieldCheckIcon, ShieldExclamationIcon, LockClosedIcon, EyeIcon, ArrowPathIcon, ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import Layout from '../../components/Layout';
import StatCard from '../../components/StatCard';

const C = { teal:'#00B4D8', success:'#10B981', dark:'#1F2937', grey:'#6B7280', border:'#E5E7EB', warn:'#F59E0B', red:'#EF4444', purple:'#8B5CF6' };

const EVENTS = [
  { id:1, type:'login_success', user:'hello@speakiq.uk', role:'superadmin', ip:'82.148.10.1', location:'London, UK', time:'2026-03-19 09:14:22', risk:'low' },
  { id:2, type:'login_failed', user:'admin@tashkent.speakiq.uk', role:'tenant_admin', ip:'213.230.77.4', location:'Tashkent, UZ', time:'2026-03-19 08:52:11', risk:'medium' },
  { id:3, type:'login_failed', user:'admin@tashkent.speakiq.uk', role:'tenant_admin', ip:'213.230.77.4', location:'Tashkent, UZ', time:'2026-03-19 08:52:09', risk:'medium' },
  { id:4, type:'login_failed', user:'admin@tashkent.speakiq.uk', role:'tenant_admin', ip:'213.230.77.4', location:'Tashkent, UZ', time:'2026-03-19 08:52:05', risk:'high' },
  { id:5, type:'password_reset', user:'dana.s@gmail.com', role:'student', ip:'77.201.3.14', location:'Almaty, KZ', time:'2026-03-19 07:31:44', risk:'low' },
  { id:6, type:'login_success', user:'admin@almaty.speakiq.uk', role:'tenant_admin', ip:'77.201.3.14', location:'Almaty, KZ', time:'2026-03-19 07:28:02', risk:'low' },
  { id:7, type:'suspicious_ip', user:'unknown', role:'-', ip:'185.220.101.2', location:'Unknown', time:'2026-03-18 23:11:01', risk:'high' },
  { id:8, type:'jwt_expired', user:'bobur.y@mail.ru', role:'student', ip:'212.42.100.8', location:'Tashkent, UZ', time:'2026-03-18 21:00:33', risk:'low' },
  { id:9, type:'login_success', user:'tutor01@tashkent.speakiq.uk', role:'tutor', ip:'109.207.5.11', location:'Tashkent, UZ', time:'2026-03-18 18:44:12', risk:'low' },
  { id:10, type:'rate_limit_hit', user:'unknown', role:'-', ip:'91.108.4.1', location:'Moscow, RU', time:'2026-03-18 15:22:48', risk:'high' },
];

const TYPE_META = {
  login_success:  { label:'Login Success',   color:C.success, bg:'#D1FAE5', icon:ShieldCheckIcon },
  login_failed:   { label:'Login Failed',    color:C.warn,    bg:'#FEF3C7', icon:ShieldExclamationIcon },
  password_reset: { label:'Password Reset',  color:C.teal,    bg:'#E0F7FA', icon:LockClosedIcon },
  suspicious_ip:  { label:'Suspicious IP',   color:C.red,     bg:'#FEE2E2', icon:ExclamationTriangleIcon },
  jwt_expired:    { label:'Token Expired',   color:C.grey,    bg:'#F3F4F6', icon:ArrowPathIcon },
  rate_limit_hit: { label:'Rate Limit Hit',  color:C.red,     bg:'#FEE2E2', icon:ExclamationTriangleIcon },
};

const RISK_COLOR = { low: C.success, medium: C.warn, high: C.red };

const CB_STATUS = [
  { name:'Student Daily Limit ($2)', active:false, triggered:0 },
  { name:'Student Monthly Limit ($5)', active:false, triggered:0 },
  { name:'Platform Daily Limit ($20)', active:false, triggered:0 },
  { name:'Free Questions Max (3/lesson)', active:false, triggered:2 },
];

export default function SuperAdminSecurity() {
  const [filter, setFilter] = useState('all');

  const filtered = filter === 'all' ? EVENTS : EVENTS.filter(e => e.risk === filter);
  const highCount = EVENTS.filter(e => e.risk === 'high').length;
  const failedLogins = EVENTS.filter(e => e.type === 'login_failed').length;

  return (
    <Layout role="superadmin">
      {/* Stats */}
      <div style={{ display:'grid', gridTemplateColumns:'repeat(4,1fr)', gap:20, marginBottom:24 }}>
        <StatCard title="Security Events (24h)" value={EVENTS.length} icon={ShieldCheckIcon} color={C.teal} />
        <StatCard title="High Risk Events" value={highCount} icon={ShieldExclamationIcon} color={C.red} />
        <StatCard title="Failed Logins" value={failedLogins} icon={LockClosedIcon} color={C.warn} />
        <StatCard title="Active Sessions" value={47} icon={EyeIcon} color={C.success} />
      </div>

      <div style={{ display:'grid', gridTemplateColumns:'1fr 320px', gap:20, marginBottom:24 }}>
        {/* Event Log */}
        <div className="card" style={{ overflow:'hidden' }}>
          <div style={{ padding:'20px 24px', borderBottom:`1px solid ${C.border}`, display:'flex', gap:8, alignItems:'center' }}>
            <h3 style={{ margin:0, fontSize:15, fontWeight:700, flex:1 }}>Security Event Log</h3>
            {['all','high','medium','low'].map(r => (
              <button key={r} onClick={() => setFilter(r)} style={{ padding:'6px 14px', borderRadius:20, fontSize:12, fontWeight:600, cursor:'pointer', border: filter === r ? 'none' : `1px solid ${C.border}`, background: filter === r ? (r === 'high' ? C.red : r === 'medium' ? C.warn : r === 'low' ? C.success : C.dark) : '#F9FAFB', color: filter === r ? '#fff' : C.grey }}>
                {r === 'all' ? 'All' : r.charAt(0).toUpperCase() + r.slice(1)}
              </button>
            ))}
          </div>
          <div style={{ maxHeight:420, overflowY:'auto' }}>
            {filtered.map((ev, i) => {
              const meta = TYPE_META[ev.type] || TYPE_META.login_success;
              const Icon = meta.icon;
              return (
                <div key={ev.id} style={{ padding:'14px 24px', borderBottom:`1px solid ${C.border}`, display:'flex', alignItems:'flex-start', gap:12, background: i % 2 === 0 ? '#fff' : '#FAFAFA' }}>
                  <div style={{ width:32, height:32, borderRadius:8, background:meta.bg, display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0 }}>
                    <Icon style={{ width:16, height:16, color:meta.color }} />
                  </div>
                  <div style={{ flex:1, minWidth:0 }}>
                    <div style={{ display:'flex', alignItems:'center', gap:8, marginBottom:2 }}>
                      <span style={{ fontSize:13, fontWeight:600 }}>{meta.label}</span>
                      <span style={{ padding:'1px 8px', borderRadius:20, fontSize:11, fontWeight:600, background: ev.risk === 'high' ? '#FEE2E2' : ev.risk === 'medium' ? '#FEF3C7' : '#D1FAE5', color:RISK_COLOR[ev.risk] }}>{ev.risk}</span>
                    </div>
                    <div style={{ fontSize:12, color:C.grey }}>{ev.user} · {ev.role} · <span style={{ fontFamily:'monospace' }}>{ev.ip}</span> · {ev.location}</div>
                  </div>
                  <div style={{ fontSize:11, color:C.grey, whiteSpace:'nowrap' }}>{ev.time.split(' ')[1]}</div>
                </div>
              );
            })}
          </div>
        </div>

        {/* Right panel */}
        <div style={{ display:'flex', flexDirection:'column', gap:20 }}>
          {/* Circuit Breakers */}
          <div className="card" style={{ padding:20 }}>
            <h3 style={{ margin:'0 0 16px', fontSize:15, fontWeight:700 }}>Circuit Breakers</h3>
            {CB_STATUS.map((cb, i) => (
              <div key={i} style={{ display:'flex', alignItems:'center', gap:10, marginBottom:12 }}>
                <div style={{ width:10, height:10, borderRadius:'50%', background:cb.active ? C.red : C.success, flexShrink:0 }} />
                <div style={{ flex:1 }}>
                  <div style={{ fontSize:12, fontWeight:600 }}>{cb.name}</div>
                  <div style={{ fontSize:11, color:C.grey }}>{cb.triggered} triggers today</div>
                </div>
                <span style={{ fontSize:12, fontWeight:700, color:cb.active ? C.red : C.success }}>{cb.active ? 'OPEN' : 'OK'}</span>
              </div>
            ))}
          </div>

          {/* IP Blocklist */}
          <div className="card" style={{ padding:20 }}>
            <h3 style={{ margin:'0 0 16px', fontSize:15, fontWeight:700 }}>Flagged IPs</h3>
            {['185.220.101.2', '91.108.4.1'].map(ip => (
              <div key={ip} style={{ display:'flex', alignItems:'center', gap:10, marginBottom:10, padding:'8px 12px', background:'#FEF2F2', borderRadius:8, border:`1px solid #FECACA` }}>
                <ExclamationTriangleIcon style={{ width:14, height:14, color:C.red, flexShrink:0 }} />
                <span style={{ fontFamily:'monospace', fontSize:12, flex:1 }}>{ip}</span>
                <button style={{ fontSize:11, color:C.red, fontWeight:600, background:'none', border:'none', cursor:'pointer' }}>Block</button>
              </div>
            ))}
          </div>

          {/* JWT Config */}
          <div className="card" style={{ padding:20 }}>
            <h3 style={{ margin:'0 0 16px', fontSize:15, fontWeight:700 }}>Token Settings</h3>
            {[['Access Token TTL', '15 minutes'], ['Refresh Token TTL', '30 days'], ['Algorithm', 'HS256'], ['Active Sessions', '47']].map(([k, v]) => (
              <div key={k} style={{ display:'flex', justifyContent:'space-between', marginBottom:10, fontSize:13 }}>
                <span style={{ color:C.grey }}>{k}</span>
                <span style={{ fontWeight:600 }}>{v}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </Layout>
  );
}
